import i18n from "@/locales";

// Single source of truth for the country list (frontend).
// Canonical stored value is the ISO 3166-1 alpha-2 `key` (e.g. "FR", "CI").
// `en` / `fr` are display labels only — never stored, never matched.
// Keep this list in sync with api/src/utils/countries.js (same key/en/fr data).
export const COUNTRIES = [
  { key: "AF", en: "Afghanistan", fr: "Afghanistan" },
  { key: "AL", en: "Albania", fr: "Albanie" },
  { key: "DZ", en: "Algeria", fr: "Algérie" },
  { key: "AD", en: "Andorra", fr: "Andorre" },
  { key: "AO", en: "Angola", fr: "Angola" },
  { key: "AR", en: "Argentina", fr: "Argentine" },
  { key: "AM", en: "Armenia", fr: "Arménie" },
  { key: "AU", en: "Australia", fr: "Australie" },
  { key: "AT", en: "Austria", fr: "Autriche" },
  { key: "AZ", en: "Azerbaijan", fr: "Azerbaïdjan" },
  { key: "BH", en: "Bahrain", fr: "Bahreïn" },
  { key: "BD", en: "Bangladesh", fr: "Bangladesh" },
  { key: "BY", en: "Belarus", fr: "Biélorussie" },
  { key: "BE", en: "Belgium", fr: "Belgique" },
  { key: "BJ", en: "Benin", fr: "Bénin" },
  { key: "BO", en: "Bolivia", fr: "Bolivie" },
  { key: "BA", en: "Bosnia and Herzegovina", fr: "Bosnie-Herzégovine" },
  { key: "BW", en: "Botswana", fr: "Botswana" },
  { key: "BR", en: "Brazil", fr: "Brésil" },
  { key: "BG", en: "Bulgaria", fr: "Bulgarie" },
  { key: "BF", en: "Burkina Faso", fr: "Burkina Faso" },
  { key: "BI", en: "Burundi", fr: "Burundi" },
  { key: "KH", en: "Cambodia", fr: "Cambodge" },
  { key: "CM", en: "Cameroon", fr: "Cameroun" },
  { key: "CA", en: "Canada", fr: "Canada" },
  { key: "CV", en: "Cape Verde", fr: "Cap-Vert" },
  { key: "CF", en: "Central African Republic", fr: "République centrafricaine" },
  { key: "TD", en: "Chad", fr: "Tchad" },
  { key: "CL", en: "Chile", fr: "Chili" },
  { key: "CN", en: "China", fr: "Chine" },
  { key: "CO", en: "Colombia", fr: "Colombie" },
  { key: "KM", en: "Comoros", fr: "Comores" },
  { key: "CD", en: "Congo (DRC)", fr: "République démocratique du Congo" },
  { key: "CR", en: "Costa Rica", fr: "Costa Rica" },
  { key: "HR", en: "Croatia", fr: "Croatie" },
  { key: "CU", en: "Cuba", fr: "Cuba" },
  { key: "CY", en: "Cyprus", fr: "Chypre" },
  { key: "CZ", en: "Czech Republic", fr: "République tchèque" },
  { key: "DK", en: "Denmark", fr: "Danemark" },
  { key: "DJ", en: "Djibouti", fr: "Djibouti" },
  { key: "DO", en: "Dominican Republic", fr: "République dominicaine" },
  { key: "EC", en: "Ecuador", fr: "Équateur" },
  { key: "EG", en: "Egypt", fr: "Égypte" },
  { key: "SV", en: "El Salvador", fr: "Salvador" },
  { key: "GQ", en: "Equatorial Guinea", fr: "Guinée équatoriale" },
  { key: "EE", en: "Estonia", fr: "Estonie" },
  { key: "SZ", en: "Eswatini", fr: "Eswatini" },
  { key: "ET", en: "Ethiopia", fr: "Éthiopie" },
  { key: "FI", en: "Finland", fr: "Finlande" },
  { key: "FR", en: "France", fr: "France" },
  { key: "GF", en: "French Guiana", fr: "Guyane française" },
  { key: "GA", en: "Gabon", fr: "Gabon" },
  { key: "GM", en: "Gambia", fr: "Gambie" },
  { key: "GE", en: "Georgia", fr: "Géorgie" },
  { key: "DE", en: "Germany", fr: "Allemagne" },
  { key: "GH", en: "Ghana", fr: "Ghana" },
  { key: "GR", en: "Greece", fr: "Grèce" },
  { key: "GT", en: "Guatemala", fr: "Guatemala" },
  { key: "GN", en: "Guinea", fr: "Guinée" },
  { key: "HT", en: "Haiti", fr: "Haïti" },
  { key: "HN", en: "Honduras", fr: "Honduras" },
  { key: "HK", en: "Hong Kong", fr: "Hong Kong" },
  { key: "HU", en: "Hungary", fr: "Hongrie" },
  { key: "IS", en: "Iceland", fr: "Islande" },
  { key: "IN", en: "India", fr: "Inde" },
  { key: "ID", en: "Indonesia", fr: "Indonésie" },
  { key: "IR", en: "Iran", fr: "Iran" },
  { key: "IQ", en: "Iraq", fr: "Irak" },
  { key: "IE", en: "Ireland", fr: "Irlande" },
  { key: "IL", en: "Israel", fr: "Israël" },
  { key: "IT", en: "Italy", fr: "Italie" },
  { key: "CI", en: "Ivory Coast", fr: "Côte d'Ivoire" },
  { key: "JM", en: "Jamaica", fr: "Jamaïque" },
  { key: "JP", en: "Japan", fr: "Japon" },
  { key: "JO", en: "Jordan", fr: "Jordanie" },
  { key: "KZ", en: "Kazakhstan", fr: "Kazakhstan" },
  { key: "KE", en: "Kenya", fr: "Kenya" },
  { key: "XK", en: "Kosovo", fr: "Kosovo" },
  { key: "KW", en: "Kuwait", fr: "Koweït" },
  { key: "KG", en: "Kyrgyzstan", fr: "Kirghizistan" },
  { key: "LV", en: "Latvia", fr: "Lettonie" },
  { key: "LB", en: "Lebanon", fr: "Liban" },
  { key: "LS", en: "Lesotho", fr: "Lesotho" },
  { key: "LR", en: "Liberia", fr: "Liberia" },
  { key: "LY", en: "Libya", fr: "Libye" },
  { key: "LT", en: "Lithuania", fr: "Lituanie" },
  { key: "LU", en: "Luxembourg", fr: "Luxembourg" },
  { key: "MG", en: "Madagascar", fr: "Madagascar" },
  { key: "MW", en: "Malawi", fr: "Malawi" },
  { key: "MY", en: "Malaysia", fr: "Malaisie" },
  { key: "MV", en: "Maldives", fr: "Maldives" },
  { key: "ML", en: "Mali", fr: "Mali" },
  { key: "MT", en: "Malta", fr: "Malte" },
  { key: "MQ", en: "Martinique", fr: "Martinique" },
  { key: "MR", en: "Mauritania", fr: "Mauritanie" },
  { key: "MU", en: "Mauritius", fr: "Maurice" },
  { key: "YT", en: "Mayotte", fr: "Mayotte" },
  { key: "MX", en: "Mexico", fr: "Mexique" },
  { key: "MD", en: "Moldova", fr: "Moldavie" },
  { key: "MC", en: "Monaco", fr: "Monaco" },
  { key: "MN", en: "Mongolia", fr: "Mongolie" },
  { key: "ME", en: "Montenegro", fr: "Monténégro" },
  { key: "MA", en: "Morocco", fr: "Maroc" },
  { key: "MZ", en: "Mozambique", fr: "Mozambique" },
  { key: "MM", en: "Myanmar", fr: "Birmanie (Myanmar)" },
  { key: "NA", en: "Namibia", fr: "Namibie" },
  { key: "NP", en: "Nepal", fr: "Népal" },
  { key: "NL", en: "Netherlands", fr: "Pays-Bas" },
  { key: "NC", en: "New Caledonia", fr: "Nouvelle-Calédonie" },
  { key: "NZ", en: "New Zealand", fr: "Nouvelle-Zélande" },
  { key: "NI", en: "Nicaragua", fr: "Nicaragua" },
  { key: "NE", en: "Niger", fr: "Niger" },
  { key: "NG", en: "Nigeria", fr: "Nigéria" },
  { key: "MK", en: "North Macedonia", fr: "Macédoine du Nord" },
  { key: "NO", en: "Norway", fr: "Norvège" },
  { key: "OM", en: "Oman", fr: "Oman" },
  { key: "PK", en: "Pakistan", fr: "Pakistan" },
  { key: "PS", en: "Palestinian Territories", fr: "Territoires palestiniens" },
  { key: "PA", en: "Panama", fr: "Panama" },
  { key: "PY", en: "Paraguay", fr: "Paraguay" },
  { key: "PE", en: "Peru", fr: "Pérou" },
  { key: "PH", en: "Philippines", fr: "Philippines" },
  { key: "PL", en: "Poland", fr: "Pologne" },
  { key: "PT", en: "Portugal", fr: "Portugal" },
  { key: "QA", en: "Qatar", fr: "Qatar" },
  { key: "RE", en: "Reunion", fr: "La Réunion" },
  { key: "RO", en: "Romania", fr: "Roumanie" },
  { key: "RU", en: "Russia", fr: "Russie" },
  { key: "RW", en: "Rwanda", fr: "Rwanda" },
  { key: "SM", en: "San Marino", fr: "Saint-Marin" },
  { key: "SA", en: "Saudi Arabia", fr: "Arabie saoudite" },
  { key: "SN", en: "Senegal", fr: "Sénégal" },
  { key: "RS", en: "Serbia", fr: "Serbie" },
  { key: "SL", en: "Sierra Leone", fr: "Sierra Leone" },
  { key: "SG", en: "Singapore", fr: "Singapour" },
  { key: "SK", en: "Slovakia", fr: "Slovaquie" },
  { key: "SI", en: "Slovenia", fr: "Slovénie" },
  { key: "SO", en: "Somalia", fr: "Somalie" },
  { key: "ZA", en: "South Africa", fr: "Afrique du Sud" },
  { key: "KR", en: "South Korea", fr: "Corée du Sud" },
  { key: "ES", en: "Spain", fr: "Espagne" },
  { key: "LK", en: "Sri Lanka", fr: "Sri Lanka" },
  { key: "SD", en: "Sudan", fr: "Soudan" },
  { key: "SE", en: "Sweden", fr: "Suède" },
  { key: "CH", en: "Switzerland", fr: "Suisse" },
  { key: "SY", en: "Syria", fr: "Syrie" },
  { key: "TW", en: "Taiwan", fr: "Taïwan" },
  { key: "TZ", en: "Tanzania", fr: "Tanzanie" },
  { key: "TH", en: "Thailand", fr: "Thaïlande" },
  { key: "TG", en: "Togo", fr: "Togo" },
  { key: "TN", en: "Tunisia", fr: "Tunisie" },
  { key: "TR", en: "Turkey", fr: "Turquie" },
  { key: "UG", en: "Uganda", fr: "Ouganda" },
  { key: "UA", en: "Ukraine", fr: "Ukraine" },
  { key: "AE", en: "United Arab Emirates", fr: "Émirats arabes unis" },
  { key: "GB", en: "United Kingdom", fr: "Royaume-Uni" },
  { key: "US", en: "United States", fr: "États-Unis" },
  { key: "UY", en: "Uruguay", fr: "Uruguay" },
  { key: "UZ", en: "Uzbekistan", fr: "Ouzbékistan" },
  { key: "VU", en: "Vanuatu", fr: "Vanuatu" },
  { key: "VE", en: "Venezuela", fr: "Venezuela" },
  { key: "VN", en: "Vietnam", fr: "Viêt Nam" },
  { key: "YE", en: "Yemen", fr: "Yémen" },
  { key: "ZM", en: "Zambia", fr: "Zambie" },
  { key: "ZW", en: "Zimbabwe", fr: "Zimbabwe" },
];

const BY_CODE = Object.fromEntries(COUNTRIES.map((c) => [c.key, c]));

const resolveLang = (lang) => ((lang || i18n.language || "en").startsWith("fr") ? "fr" : "en");

// Localized display name for a stored ISO code.
// Falls back to the raw value so legacy (un-migrated) rows still render.
export function countryLabel(code, lang) {
  if (!code) return "";
  const entry = BY_CODE[code];
  return entry ? entry[resolveLang(lang)] : code;
}

// Options for a <select>: value is the ISO code, label is localized, sorted by label.
export function countryOptions(lang) {
  const l = resolveLang(lang);
  return COUNTRIES.map((c) => ({ value: c.key, label: c[l] })).sort((a, b) => a.label.localeCompare(b.label, l));
}

// --- Free-text -> ISO code resolver (used only at ingestion edges, e.g. CSV import) ---
const fold = (s) =>
  String(s)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const NAME_TO_CODE = {};
for (const c of COUNTRIES) {
  NAME_TO_CODE[fold(c.en)] = c.key;
  NAME_TO_CODE[fold(c.fr)] = c.key;
  NAME_TO_CODE[fold(c.key)] = c.key;
}

const ALIASES = {
  usa: "US", "united states of america": "US", america: "US", american: "US",
  uk: "GB", "great britain": "GB", britain: "GB", england: "GB", "northern ireland": "GB",
  uae: "AE", "ivory coast": "CI", "ivory cost": "CI", "cote d ivoire": "CI", "cote divoire": "CI",
  "cote ivoire": "CI", ivoirienne: "CI", civ: "CI", czechia: "CZ", korea: "KR", "republic of korea": "KR",
  "korea republic of": "KR", congo: "CD", "democratic republic of the congo": "CD", "congo kinshasa": "CD", rdc: "CD",
  "iran islamic republic of": "IR", "syrian arab republic": "SY", "moldova republic of": "MD",
  "macedonia the former yugoslav republic of": "MK", macedonia: "MK", "north macedonia": "MK",
  "russian federation": "RU", "viet nam": "VN", burma: "MM", deutschland: "DE", holland: "NL",
  "the netherlands": "NL", nederland: "NL", belgie: "BE", italia: "IT", francia: "FR", marruecos: "MA",
  guinee: "GN", centrafrique: "CF", tchad: "TD", danmark: "DK", slovensko: "SK", zwitserland: "CH",
  catalunya: "ES", shqiperi: "AL", turkiye: "TR", kosove: "XK", kosova: "XK", mauritanien: "MR",
  swaziland: "SZ", tunisien: "TN", "ile de france": "FR", bali: "ID",
};

// Returns an ISO alpha-2 code or null. Mirrors api/src/utils/countries.js.
export function normalizeCountry(input) {
  if (input == null) return null;
  const raw = String(input).trim();
  if (!raw) return null;
  const upper = raw.toUpperCase();
  if (BY_CODE[upper]) return upper;
  const folded = fold(raw);
  if (NAME_TO_CODE[folded]) return NAME_TO_CODE[folded];
  if (ALIASES[folded]) return ALIASES[folded];
  for (const seg of raw.split(/[,/|&]+/).map(fold).filter(Boolean)) {
    if (NAME_TO_CODE[seg]) return NAME_TO_CODE[seg];
    if (ALIASES[seg]) return ALIASES[seg];
    if (BY_CODE[seg.toUpperCase()]) return seg.toUpperCase();
  }
  return null;
}
